export default __webpack_public_path__ + "static/img/img_6.e8f941c.png";